/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ApiRequestJoinOnDay } from '../model/models';
import { ApiRequestOptOutOnDay } from '../model/models';
import { ApiResponseGroupV2 } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface GroupV2CalendarServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     * @param apiRequestJoinOnDay 
     */
    groupV2CalendarControllerJoinOnDay0(apiRequestJoinOnDay: ApiRequestJoinOnDay, extraHttpRequestParams?: any): Observable<ApiResponseGroupV2>;

    /**
     * 
     * 
     * @param apiRequestJoinOnDay 
     */
    groupV2CalendarControllerJoinOnDay1(apiRequestJoinOnDay: ApiRequestJoinOnDay, extraHttpRequestParams?: any): Observable<ApiResponseGroupV2>;

    /**
     * 
     * 
     * @param apiRequestOptOutOnDay 
     */
    groupV2CalendarControllerOptOutOnDay0(apiRequestOptOutOnDay: ApiRequestOptOutOnDay, extraHttpRequestParams?: any): Observable<ApiResponseGroupV2>;

    /**
     * 
     * 
     * @param apiRequestOptOutOnDay 
     */
    groupV2CalendarControllerOptOutOnDay1(apiRequestOptOutOnDay: ApiRequestOptOutOnDay, extraHttpRequestParams?: any): Observable<ApiResponseGroupV2>;

}
